import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameToColor',
  standalone: true,
})
export class NameToColorPipe implements PipeTransform {
  private imageBgColors: string[] = [
    '#4A5DDE',
    '#2D3FB3',
    '#35217B',
    '#73429F',
    '#4C5B9F',
  ];

  private static makeHashCode(name: string): number {
    let hash = 0;
    const len = name.length;
    if (name.length === 0) {
      return hash;
    }
    for (let i = 0; i < len; i++) {
      const charC = name.charCodeAt(i);
      // tslint:disable-next-line:no-bitwise
      hash = (hash << 5) - hash + charC;
      // tslint:disable-next-line:no-bitwise
      hash = hash & hash;
    }

    return Math.abs(hash);
  }

  transform(name: string): string {
    if (name) {
      return this.imageBgColors[
        NameToColorPipe.makeHashCode(name) % this.imageBgColors.length
      ];
    }
  }
}
